module.exports = __webpack_public_path__ + "img/vk.31374ee.png";